/**
 * Generic loading placeholder used by the Today view and Objective Detail
 * screen's loading states (today-view.md SS3, objective-detail.md SS2).
 * Respects prefers-reduced-motion via tokens.css's global animation-duration
 * override — no bespoke reduced-motion handling needed here.
 */
export function SkeletonBlock({
  height,
  width = '100%',
  radius = 'var(--radius-md)',
}: {
  readonly height: number | string;
  readonly width?: number | string;
  readonly radius?: string;
}) {
  return (
    <div
      aria-hidden="true"
      style={{
        height: typeof height === 'number' ? `${height}px` : height,
        width: typeof width === 'number' ? `${width}px` : width,
        borderRadius: radius,
        background: 'var(--surface-raised)',
        border: '1px solid var(--border-subtle)',
        animation: 'compass-skeleton-pulse 1.4s ease-in-out infinite',
      }}
    />
  );
}
